/** @jsxRuntime classic */
// todo: remove above line in the future. This is a hack for react scripts 4 to work with IE 11
// source: https://github.com/facebook/create-react-app/issues/9906#issuecomment-719488780
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'whatwg-fetch';
import 'array.prototype.move';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Root from './Root';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <Root>
    <App />
  </Root>,
);
